<template>
  <div>
    <div v-html="getLocaleText(inputData.label)" />
  </div>
</template>

<script>
import formGtm from '@/mixins/formGtm';

export default {
  name: 'UlTextOnly',
  mixins: [formGtm],
  props: {
    inputData: {
      type: Object,
      required: true
    }
  }
};
</script>
